const exchangeAutoComplete = () =>
  import("@/components/ExchangeAutoComplete/index");
export default {
  name: "add-address-card",
  components: { exchangeAutoComplete },
  props: {
    fromCurrencyData: {
      type: Object
    },
    currenciesData: {
      type: Array
    },
    networks: {
      type: Array
    },
    selectedNetwork: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTagInput: false,
      addressValidation: "",
      walletAddressData: {
        networkTag: "",
        selectedNetwork: "",
        title: "",
        address: ""
      },
      defaultData: {
        networkTag: "",
        selectedNetwork: "",
        title: "",
        address: ""
      }
    };
  },
  computed: {
    walletAddressRegex() {
      return this.walletAddressData.selectedNetwork.regex;
    }
  },
  watch: {
    selectedNetwork: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.walletAddressData.selectedNetwork = newValue;
          if (this.showTagInput) {
            this.showTagInput = false;
          } else if (newValue.has_extra) {
            this.showTagInput = true;
          }
        }
      }
    }
  },
  mounted() {},
  methods: {
    checkAddressValidation(address) {
      if (!address.match(this.walletAddressRegex)) {
        this.addressValidation = this.$t(
          "operationsPage.withdraw.category.crypto.addressNotCorrect"
        );
      } else {
        this.addressValidation = "";
      }
      if (!address) {
        this.addressValidation = "";
      }
    },
    onSelectNetwork(network) {
      if (this.showTagInput) {
        this.showTagInput = false;
      } else if (network.has_extra) {
        this.showTagInput = true;
      }
      this.checkAddressValidation(this.walletAddressData.address);
    },
    handleDialog() {
      let cloneWalletAddress = Object.assign({}, this.walletAddressData);
      this.$emit("confirmAddAddr", cloneWalletAddress, true);
      this.resetForm();
    },
    onClose() {
      this.$emit("closeDialog", false);
      this.resetForm();
    },
    resetForm() {
      if (this.walletAddressData.title) {
        Object.assign(this.walletAddressData, this.defaultData);
      }
    }
  }
};
